export default "__VITE_ASSET__CYS8DOGO__"